app.service('GuestService', function ($http) {


    //Get  District List
    this.GetGuestList = function (itemsPerPage, pagenumber, sortKey, reverse, lang) {
        return $http.get("/api/District/GetGuestList?itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang);
    }

});